<body class="sidebar-noneoverflow">
<div class="header-container fixed-top">
  <header class="header navbar navbar-expand-sm">
    <mat-toolbar style="background: #2A499A;">
      <span class="theme-text" style="color: white; font-size: 20px;">Federata e Futbollit e Kosovës</span>
      <span class="spacer"></span>
      <mat-toolbar style="background: #2A499A;">
        <button (click)="sidenavToggle()" mat-icon-button type="button" style="color: white">
          <mat-icon>menu</mat-icon>
        </button>
        <span></span>
      </mat-toolbar>
      <div class="user-menu" style="margin-right: 1rem">
        <button [matMenuTriggerFor]="userMenuLanguage" mat-button style="color: white">
          <mat-icon>language</mat-icon> <span>{{ currentLang }}</span>
        </button>
        <mat-menu #userMenuLanguage="matMenu">
          <div class="user-profile-section">
            <div class="media mx-auto">
              <div class="media-body">
              </div>
            </div>
          </div>
          <button mat-menu-item (click)="changeLanguage('sq')">
            <span>{{ 'Albanian' | translate }}</span>
          </button>
          <button mat-menu-item (click)="changeLanguage('en')">
            <span>{{ 'English' | translate }}</span>
          </button>
        </mat-menu>
      </div>
      <div class="user-menu">
        <button [matMenuTriggerFor]="userMenu" mat-button style="color: white">
          <span class="username">{{!isEmptyObject(currentUser) ? currentUser?.email : '' }}</span>
          <mat-icon>person</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu">
          <div class="user-profile-section">
            <div class="media mx-auto">
              <div class="media-body">
              </div>
            </div>
          </div>
          <button (click)="logout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            <span>{{ 'Log Out' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
  </header>
</div>

<div class="main-container" id="container">
  <div class="sidebar-wrapper sidebar-theme">
    <mat-sidenav-container class="m-sidenav-container">
      <mat-sidenav #sidenav [ngClass]="{'m-sidenav': true, 'm-sidenav-small': sidenavSmall}" fixedInViewport="true"
                   mode="side" opened>
        <div class="m-sidenav__handle">
          <mat-nav-list>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-dashboard']" mat-list-item>
              <i class="fa-solid fa-house icon-spacing"></i>
              <span>{{ 'Dashboard' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-news-categories']" mat-list-item>
              <i class="fa-solid fa-list icon-spacing"></i>
              <span>{{ 'News Categories' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-news']" mat-list-item>
              <i class="fa-solid fa-newspaper icon-spacing"></i>
              <span>{{ 'News' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-league']" mat-list-item>
              <i class="fa-solid fa-trophy icon-spacing"></i>
              <span>{{ 'League' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-teams']" mat-list-item>
              <i class="fa-solid fa-users icon-spacing"></i>
              <span>{{ 'Teams' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-standings']" mat-list-item>
              <i class="fa-solid fa-list icon-spacing"></i>
              <span>{{ 'Standings' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-national-games']" mat-list-item>
              <i class="fa-solid fa-flag icon-spacing"></i>
              <span>{{ 'National Games' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-ffk-tv']" mat-list-item>
              <i class="fa-brands fa-youtube icon-spacing"></i>
              <span>{{ 'FFK TV' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-volunteers']" mat-list-item>
              <i class="fa-solid fa-user-group icon-spacing"></i>
              <span>{{ 'Voluntary' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator || isCoach" [routerLink]="['/admin-panel/admin-coach-applications']" mat-list-item>
              <i class="fa-solid fa-user-group icon-spacing"></i>
              <span>{{ 'Coaches' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator" [routerLink]="['/admin-panel/admin-manage-users']" mat-list-item>
              <i class="fa-solid fa-user-group icon-spacing"></i>
              <span>{{ 'Users' | translate }}</span>
            </a>
            <a *ngIf="isAdministrator || isCoach" [routerLink]="['/admin-panel/admin-profile']" mat-list-item>
              <i class="fa-solid fa-user icon-spacing"></i>
              <span>{{ 'Profili' | translate }}</span>
            </a>
          </mat-nav-list>
        </div>
      </mat-sidenav>
      <mat-sidenav-content [ngClass]="{'m-main': true, 'm-main-large': sidenavSmall}">
        <div class="content-wrapper">
          <div class="layout-px-spacing">
            <router-outlet></router-outlet>
          </div>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  </div>
</div>
</body>
